import { TLocations, TLocationId } from 'types/locations';

const getLocationName = (id: TLocationId, locations?: TLocations) => {
  const location = locations?.find((item) => Number(item[0]) === Number(id));

  return location ? location[1] : 'Неизвестное местоположение';
};

export default getLocationName;
